module.exports = __webpack_public_path__ + "static/media/roar_logo_header.addb2f4c.svg";